<template>
  <el-collapse accordion>
    <el-collapse-item :title="`${$t('Riesgos Nivel')} ${risk[0].riskLevel}`">
      <el-row>
        <el-col :span="24">
          <div style="float: right; margin-bottom: 10px;">
            <label><b>{{$t('Cantidad de pasos')}}: </b></label>
            <el-input-number
              v-model="totalSteps"
              @change="setSteps"
              :min="1"
              size="medium">
            </el-input-number>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4">
          <el-steps :space="100" direction="vertical" :active="risk.length">
            <el-step
              v-for="step in risk.length"
              v-bind:key="step"
              :title="'Paso '+(step)">
            </el-step>
          </el-steps>
        </el-col>
        <el-col :span="20">
          <div
            v-for="(step, index) in risk"
            v-bind:key="index">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="line-height: 36px;">
                  <b>{{$t('Paso')}} {{ index + 1 }}</b>
                  <el-button
                    v-if="risk.length > 1"
                    type="primary"
                    icon="el-icon-delete"
                    size="small"
                    style="float: right"
                    @click="deleteStep(index)">
                  </el-button>
                </span>
              </div>
              <WorkflowCreateStep :step="step"></WorkflowCreateStep>
            </el-card>
            <br>
          </div>
        </el-col>
      </el-row>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import WorkflowCreateStep from '@/components/workflows/WorkflowCreateStep.vue';

export default {
  name: 'WorkflowCreate',
  components: {
    WorkflowCreateStep,
  },
  props: [
    'risk',
  ],
  data() {
    return {
      totalSteps: 1,
    };
  },
  methods: {
    setSteps() {
      if (this.totalSteps > this.risk.length) {
        this.risk.push({
          riskLevel: this.risk[0].riskLevel,
          totalPeople: 1,
          minToApprove: 1,
          returnTo: 0,
          peopleProfile: [
            null,
          ],
          people: [
            null,
          ],
        });
      } else if (this.totalSteps < this.risk.length) {
        this.risk.pop();
      }
    },
    deleteStep(index) {
      if (this.risk.length - 1 > 0) {
        this.risk.splice(index, 1);
        this.totalSteps -= 1;
      }
    },
  },
};
</script>
